import React from "react";
import PropTypes from "prop-types";

const TFoot = ({
  children,
  ...props
}) => /*#__PURE__*/React.createElement("tfoot", props, children);

export default TFoot;
TFoot.propTypes = {
  /** The table foot contents. */
  children: PropTypes.node
};